import { render, staticRenderFns } from "./SysTable.vue?vue&type=template&id=d686039c&scoped=true"
import script from "./SysTable.vue?vue&type=script&lang=js"
export * from "./SysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d686039c",
  null
  
)

export default component.exports